import { toUnits } from '../constants/toUnits'
import { DEVICE_DEFAULT_MAX_SIZE } from './DEVICE_DEFAULT_MAX_SIZE'

export const toNumber = (str) => {
  let num = parseInt(str, 10)
  if (Number.isNaN(num)) {
    return 0
  } else {
    return num
  }
}

const isUseMinPCSize = (size) => (size && String(size).indexOf('px') !== -1 ? `${size}, ` : '')

export const getBreakPoints = (minPCSize) => {
  const maxSizes = {
    ss: toUnits(DEVICE_DEFAULT_MAX_SIZE?.ss, 'px'),
    xs: toUnits(DEVICE_DEFAULT_MAX_SIZE?.xs, 'px'),
    sml: toUnits(DEVICE_DEFAULT_MAX_SIZE?.sml, 'px'),
    sm: toUnits(DEVICE_DEFAULT_MAX_SIZE?.sm, 'px'),
    md: toUnits(DEVICE_DEFAULT_MAX_SIZE?.md, 'px'),
  }

  const isAllowWidth = Boolean(minPCSize) && !String(minPCSize).includes('vw') && !String(minPCSize).includes('%')

  return {
    MEDIA_QUERY: {
      lg: `@media all`,
      md: `@media (max-width: max(${toUnits(DEVICE_DEFAULT_MAX_SIZE.lg - 1, 'px')}${isAllowWidth ? `,${minPCSize}` : ''}))`,
      sml: `@media (max-width: ${toUnits(DEVICE_DEFAULT_MAX_SIZE.md, 'px')})`,
      sm: `@media (max-width: ${toUnits(DEVICE_DEFAULT_MAX_SIZE.sml, 'px')})`,
      xs: `@media (max-width: ${toUnits(DEVICE_DEFAULT_MAX_SIZE.sm, 'px')})`,
      ss: `@media (max-width: ${toUnits(DEVICE_DEFAULT_MAX_SIZE.xs, 'px')})`,
    },
    maxSizes,
  }
}
